import React from 'react'
import { MapIntelligenceStats } from 'redux/mapIntelligence/mapIntelligenceTypes'
import styled from 'styled-components'
import KeyMetricsAgony from './KeyMetrics/KeyMetricsAgony'
import KeyMetricsModes from './KeyMetrics/KeyMetricsModes'

const Container = styled.div`
  ${(props) => props.theme.baseCard}
  padding: 1.5rem;
`

const displayKeyMetrics = (
  carReach: number,
  micromobilityReach: number,
  transitReach: number,
  activeLayer: string,
  statistics: MapIntelligenceStats
) => {
  if (activeLayer === 'commuteModes') {
    const renderDataNumbers = []
    const renderDataLabels = []

    if (micromobilityReach) {
      renderDataNumbers.push(micromobilityReach)
      renderDataLabels.push('Micro')
    }

    if (carReach) {
      renderDataNumbers.push(carReach)
      renderDataLabels.push('Driving')
    }
    if (transitReach) {
      renderDataNumbers.push(transitReach)
      renderDataLabels.push('Transit')
    }

    return (
      <Container>
        <KeyMetricsModes data={renderDataNumbers} labels={renderDataLabels} />
      </Container>
    )
  } else if (activeLayer === 'agony') {
    return (
      <Container>
        <KeyMetricsAgony
          agonyStats={statistics.agony}
          totalEmployees={statistics.totalEmployees}
        />
      </Container>
    )
  } else {
    return <div>No Key Metrics</div>
  }
}

interface MapIntelligenceKeyMetricsProps {
  carReach: number
  micromobilityReach: number
  transitReach: number
  activeLayer: string
  statistics: MapIntelligenceStats
}

const MapIntelligenceKeyMetrics = React.memo(
  (props: MapIntelligenceKeyMetricsProps) => {
    const {
      carReach,
      micromobilityReach,
      transitReach,
      activeLayer,
      statistics,
    } = props
    return displayKeyMetrics(
      carReach,
      micromobilityReach,
      transitReach,
      activeLayer,
      statistics
    )
  }
)

export default MapIntelligenceKeyMetrics
